var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"pagination":false,"editable":false},scopedSlots:_vm._u([{key:"item.venues",fn:function({ value }){return [_vm._v(" "+_vm._s(_vm._f("prettyArray")(_vm.getVenueNames(value)))+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }